import { TypeInterface } from "../TypeInterface";
import { Type } from "../Type";
import Translator from "../../../../../Translation/Translator";

class Owner extends Type implements TypeInterface  {

  public static companyTypeId: number = 2;
  public static isSelectable: boolean = true;

  public getName(): string {
    return Translator.trans("type-owner");
  }

}

export { Owner };
